import type { ReactNode } from 'react';

export const symbol_pinboard: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M232.5-88.63Q224-97.25 224-110v-173H93q-17.38 0-25.69-15Q59-313 67-328l75-134v-112h-32q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-634 110-634h288q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5h-32v112l75 134q8 15-.31 30T415-283H284v173q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63ZM820-160H521q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h299v-520H110q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-800 110-800h710q24 0 42 18t18 42v520q0 24-18 42t-42 18ZM144-343h219l-57-102v-129H202v129l-58 102Zm110 0Z"
		/>
	</svg>
);
